import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TwoColTwoRowPanelComponent } from './two-col-two-row-panel.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { LottieModule } from 'ngx-lottie';
import player from 'lottie-web';

export function playerFactory() {
  return player;
}

@NgModule({
  declarations: [TwoColTwoRowPanelComponent],
  exports: [TwoColTwoRowPanelComponent],
  imports: [
    CommonModule,
    SharedModule,
    TranslateModule,
    [LottieModule.forRoot({ player: playerFactory })],
  ],
})
export class TwoColTwoRowPanelModule { }
